import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { useParams } from 'react-router-dom';

const AddSale = () => {
  const { id } = useParams();

  const [planData, setPlanData] = useState({
    saleName: '',
    salePrice: '',
    saleDate: ''
  });

  const [loading, setLoader] = useState(false);
  const [courseDetails, setCourseDetails] = useState({});

  const isFormValid = () => {
    return planData.saleName && !isNaN(planData.salePrice) && planData.salePrice !== '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    fetchCourseDetails(id);
  }, [id]);

  const fetchCourseDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${courseId}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCourseDetails(result?.course);
        setPlanData({
          saleName: result?.course?.saleName || '',
          saleDate: result?.course?.saleDate || '',
          salePrice: result?.course?.salePrice || ''
        });
        setLoader(false);
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) {
      toast.error('Please fill all fields correctly.');
      return;
    }

    setLoader(true);

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);

    const raw = JSON.stringify({
      saleName: planData.saleName,
      saleValidDate: planData.saleDate,
      salePrice: planData.salePrice
    });

    const requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    try {
      const courseResponse = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/course/${id}`,
        requestOptions
      );
      const courseResult = await courseResponse.json();

      if (courseResult?.success === false) {
        if (courseResult?.message === 'Expired') {
          localStorage.clear();
          window.location.reload();
        } else {
          toast.error(courseResult?.message);
        }
      } else {
        toast.success(courseResult?.message);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while updating the course.');
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <div className="p-5">
        <form onSubmit={bannerSubmit}>
          <div className="flex gap-5 flex-wrap">
            <div className=" w-full">
              <Input
                label={'Sale End Date'}
                type={'date'}
                placeholder={'Sale Date'}
                className={'bg-gray-100 px-2 w-full'}
                name="saleDate"
                value={planData.saleDate}
                onChange={handleChange}
              />
            </div>
            <div className="sm:w-[48%] w-full">
              <Input
                label={'Sale Name'}
                placeholder={'Sale Name'}
                className={'bg-gray-100 px-2 w-full'}
                name="saleName"
                value={planData.saleName}
                onChange={handleChange}
              />
            </div>

            <div className="sm:w-[48%] w-full">
              <Input
                label={'New Price'}
                placeholder={''}
                className={'bg-gray-100 px-2 w-full'}
                name="salePrice"
                value={planData.salePrice}
                onChange={handleChange}
              />
            </div>
          </div>

          {loading ? (
            <button
              disabled
              type="button"
              className=" bg-secondary w-full text-center mt-3 py-2.5 rounded-lg text-white font-semibold cursor-pointer"
            >
              Loading...
            </button>
          ) : (
            <button
              type="submit"
              className={`w-full mt-3  bg-secondary py-2.5 rounded-md text-white text-sm font-medium ${
                !isFormValid() && 'cursor-not-allowed opacity-50'
              }`}
              disabled={!isFormValid()}
            >
              Save
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default AddSale;
